import { globalHistory } from '@reach/router';
export var onInitialClientRender = function onInitialClientRender() {
  /**
   * This is a workaround for a bug in Gatsby
   *
   * See https://github.com/gatsbyjs/gatsby/issues/8357 for more details
   */
  globalHistory._onTransitionComplete();
};
export { wrapPageElement, wrapRootElement } from './browser';